import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { BiometricService } from 'app/core/auth/biometric.service';

@Injectable({
    providedIn: 'root',
})
export class LogoutService {
    constructor(
        private authService: AuthService,
        private biometricService: BiometricService,
        private router: Router
    ) {}

    /**
     * Logout dengan hit API dan redirect ke login
     * Biometric credentials dipertahankan agar user bisa login fingerprint lagi
     */
    logoutAndRedirect(): void {
        this.authService.signOut().subscribe({
            next: () => {
                console.log('Logout berhasil');
                // Redirect ke login page
                this.router.navigate(['/sign-in'], { replaceUrl: true });
            },
            error: (err) => {
                console.error('Logout error:', err);
                // Tetap redirect meskipun error
                this.router.navigate(['/sign-in'], { replaceUrl: true });
            },
        });
    }

    /**
     * Logout dan hapus juga biometric credentials (full logout)
     */
    logoutAndClearBiometric(): void {
        this.biometricService.clearCredentials().then(() => {
            this.logoutAndRedirect();
        });
    }
}
